<div class="content-section" *ngIf="content$ | async as data; else loadingTpl">
  <ng-container *ngIf="data['Conoce-mas-sobre-la-reforma']?.beneficios?.['aumento-pgu'] as pgu">
    <div class="text-content">
      <p class="description" [innerHTML]="pgu.description"></p>

      <section class="requirements-section" aria-labelledby="pgu-requirements-title">
        <h2 id="pgu-requirements-title">{{ pgu.requirementsTitle }}</h2>
        <ul>
          <li *ngFor="let req of pgu.requirements">{{ req }}</li>
        </ul>
      </section>

      <h2 class="timeline-title">{{ pgu.timelineTitle }}</h2>

      <div class="infographic">
        <p class="visually-hidden">
          Aumento progresivo de la PGU desde septiembre de 2025 hasta septiembre de 2027
        </p>
        <icon-aumento-pgu-infografia *ngIf="!isVersionMobile" aria-hidden="true"></icon-aumento-pgu-infografia>
        <icon-aumento-pgu-infografia-mobile *ngIf="isVersionMobile" aria-hidden="true"></icon-aumento-pgu-infografia-mobile>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loadingTpl>
  <app-text-skeleton [lines]="4"></app-text-skeleton>
</ng-template>